module.exports = __webpack_public_path__ + "static/img/error.b49799c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.jpg
// module id = aedp
// module chunks = 17